interface FlagIconProps extends React.SVGProps<SVGSVGElement> {
  Component: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

const FlagIcon: React.FC<FlagIconProps> = ({ Component, ...props }) => {
  return <Component {...props} />;
};

export default FlagIcon;
